import { AttachmentEntityInterface } from '@types';

export const executeAttachment = (
  attachments: AttachmentEntityInterface[] = [],
  name = ''
): AttachmentEntityInterface | undefined => {
  return attachments.find(
    (item: AttachmentEntityInterface) => item.name === name || item.name === `${name}.png`
  );
};
